export default __webpack_public_path__ + "static/media/purple-solid.490c5529.svg";